export default "__VITE_ASSET__qeRjQHiz__"